import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["codeInput", "combinedCode"]

  connect() {
    this.initializeTOTPInputs()
  }

  initializeTOTPInputs() {
    this.codeInputTargets.forEach((input, index) => {
      input.addEventListener('input', (e) => {
        this.handleInput(e, index)
      })
      
      input.addEventListener('keydown', (e) => {
        this.handleKeydown(e, index)
      })
    })
  }

  handleInput(event, index) {
    const value = event.target.value
    
    if (value.length === 1) {
      // Move to next input
      if (index < this.codeInputTargets.length - 1) {
        this.codeInputTargets[index + 1].focus()
      }
    }
    
    this.updateCombinedCode()
  }

  handleKeydown(event, index) {
    if (event.key === 'Backspace' && event.target.value === '') {
      // Move to previous input on backspace
      if (index > 0) {
        this.codeInputTargets[index - 1].focus()
      }
    }
  }

  updateCombinedCode() {
    const combinedCode = this.codeInputTargets
      .map(input => input.value)
      .join('')
    
    this.combinedCodeTarget.value = combinedCode
  }

  handleTOTPPaste(event) {
    event.preventDefault()
    const pastedData = event.clipboardData.getData('text')
    const digits = pastedData.replace(/\D/g, '').slice(0, 6)
    
    this.codeInputTargets.forEach((input, index) => {
      input.value = digits[index] || ''
    })
    
    this.updateCombinedCode()
  }

  handleSubmit(event) {
    event.preventDefault()
    
    const formData = new FormData(event.target)
    
    fetch(event.target.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => {
      if (response.redirected) {
        window.location.href = response.url
      } else {
        return response.json()
      }
    })
    .then(data => {
      if (data && data.error) {
        alert(data.error)
      } else if (data && data.success) {
        window.location.href = data.redirect_url
      }
    })
    .catch(error => {
      console.error('Error:', error)
    })
  }
} 